<template>
  <div class="main-body-container" style="display: flex;">
    <el-tabs
      v-model="activeTabKey"
      class="absolute"
      style="width: 100%;"
      @tab-click="handleTabClick"
    >
      <el-tab-pane label="厨房冷柜" name="first" lazy><Kitchen ref="kitchen" /></el-tab-pane>
      <el-tab-pane label="红酒柜" name="second" lazy><Wine ref="wine" /></el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Kitchen from './Kitchen'
import Wine from './Wine'
export default {
  components: {
    Kitchen,
    Wine
  },
  data() {
    return {
      activeTabKey: 'first'
    }
  },
  methods: {
    handleTabClick(tab) {
      if (tab.name === 'first') {
        this.$refs.kitchen && this.$refs.kitchen.formSearch()
      } else if (tab.name === 'second') {
        this.$refs.wine && this.$refs.wine.formSearch()
      }
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.el-tabs.absolute {
  position: relative;
  .el-tabs__header {
    position: absolute;
    top: -36px;
    left: 220px;
  }
}
</style>
